var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "breadcrumb" }, [_c("navbar")], 1),
      _c("div", { staticClass: "Box" }, [
        _c("div", { staticClass: "table_tab" }, [
          _c(
            "div",
            { staticClass: "inquiry" },
            [
              _vm._m(0),
              _c(
                "el-form",
                {
                  ref: "queryForm",
                  attrs: {
                    inline: true,
                    model: _vm.search,
                    "label-width": "",
                    size: "mini",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "平台" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择平台",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.search.platformId,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "platformId", $$v)
                            },
                            expression: "search.platformId",
                          },
                        },
                        _vm._l(_vm.platformList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { plain: "", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("search")
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.fetchData("search")
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { plain: "", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("reset")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "inquiryTab" }, [
            _c(
              "div",
              { staticClass: "inquiryTab_header" },
              [
                _c("div", { staticClass: "tabTitle" }, [_vm._v("列表数据")]),
                _vm.parArray.indexOf("appNavigate_save") != -1
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.addClassify()
                          },
                        },
                      },
                      [_vm._v("新 增")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "table" },
              [
                _c("matrix-table", {
                  attrs: {
                    dataList: _vm.manage.page.list,
                    config: _vm.manage.config,
                    loading: _vm.loading,
                    sortable: "",
                  },
                  on: { receiveData: _vm.handlerSkip },
                }),
                _c("div", { staticClass: "page" }, [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.manage.page.pageNo,
                          "page-size": _vm.manage.page.pageSize,
                          "page-sizes": [3, 5, 10, 20, 50],
                          layout: "total,sizes, prev, pager, next",
                          total: _vm.manage.page.totalNum,
                        },
                        on: {
                          "size-change": _vm.onSizeChange,
                          "current-change": _vm.onCurrentChange,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "跳转设置",
            visible: _vm.dialogVisible,
            "append-to-body": "",
            width: "30%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "主图:", prop: "image" } },
                    [
                      _vm.ruleForm.image == ""
                        ? _c(
                            "el-upload",
                            {
                              ref: "upload",
                              staticClass: "avatar-uploader",
                              attrs: {
                                action: "#",
                                limit: 1,
                                "on-exceed": _vm.test,
                                "before-upload": _vm.beforeAvatarUpload,
                                "http-request": _vm.imgUpload,
                                "file-list": _vm.fileListImg,
                                "show-file-list": false,
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                                staticStyle: { "font-size": "18px" },
                              }),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                padding: "2px",
                                "margin-right": "5px",
                                position: "relative",
                              },
                            },
                            [
                              _c("img", {
                                directives: [
                                  {
                                    name: "image-preview",
                                    rawName: "v-image-preview",
                                  },
                                ],
                                staticStyle: { width: "90px", height: "90px" },
                                attrs: {
                                  src: _vm.ruleForm.image || _vm.ruleForm.image,
                                },
                              }),
                              _c("i", {
                                staticClass: "el-icon-error",
                                staticStyle: {
                                  position: "absolute",
                                  top: "-5px",
                                  right: "-6px",
                                  cursor: "pointer",
                                  "z-index": "999",
                                  "font-size": "15px",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteImg()
                                  },
                                },
                              }),
                            ]
                          ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "平台:", prop: "pingtai" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "80%" },
                          attrs: { placeholder: "请选择平台", multiple: "" },
                          model: {
                            value: _vm.ruleForm.pingtai,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "pingtai", $$v)
                            },
                            expression: "ruleForm.pingtai",
                          },
                        },
                        _vm._l(_vm.platformList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "名称:", prop: "name" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "80%" },
                        model: {
                          value: _vm.ruleForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "name", $$v)
                          },
                          expression: "ruleForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "链接:", prop: "url" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "80%" },
                        model: {
                          value: _vm.ruleForm.url,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "url", $$v)
                          },
                          expression: "ruleForm.url",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序:", prop: "paixu" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "80%" },
                        attrs: {
                          oninput:
                            "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')",
                        },
                        model: {
                          value: _vm.ruleForm.paixu,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "paixu", $$v)
                          },
                          expression: "ruleForm.paixu",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "appId:", prop: "appid" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "80%" },
                        model: {
                          value: _vm.ruleForm.appid,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "appid", $$v)
                          },
                          expression: "ruleForm.appid",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否显示:" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticStyle: { width: "80%" },
                          model: {
                            value: _vm.ruleForm.radio,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "radio", $$v)
                            },
                            expression: "ruleForm.radio",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "btnClass" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submit("ruleForm")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "headerbox" }, [
      _c("div", { staticClass: "header" }, [_vm._v(" 数据筛选 ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }